<template>
    <div class="about-initiative-form14">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group label="Qual o tipo do seu serviço?" label-for="serviceType" class="required">
                <b-form-checkbox-group
                    id="service-type"
                    name="serviceType"
                    v-model="$v.form.serviceType.selected.$model"
                    :options="form.serviceType.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('serviceType')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['tipo_servico'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['tipo_servico'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.serviceTypeOthers"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.serviceType.selected.includes(10)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('serviceType')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Para quem você vende seus serviços?" label-for="buyer">
                <b-form-checkbox-group
                    id="buyer"
                    name="buyer"
                    v-model="form.buyer.selected"
                    :options="form.buyer.options"
                    value-field="item"
                    text-field="text"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['para_quem_vende_servico'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['para_quem_vende_servico'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.buyerOthers"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="
                        (form.buyer.selected.includes(6) && !isPlatform) ||
                            (isPlatform &&
                                form.buyer.selected.includes(6) &&
                                getAuthorizationData &&
                                getAuthorizationData['para_quem_vende_servico'].value)
                    "
                ></b-form-input>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutInitiativeForm12' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutInitiativeForm12')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="
                            changeRegisterForm(
                                initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : 'AboutInitiativeForm9'
                            )
                        "
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            initiative: null,
            progress: 38.78,
            message: null,
            authorizationData: null,
            isUpdate: false,
            form: {
                serviceType: {
                    selected: [],
                    options: [
                        { text: 'Audiovisual', item: 1, value: 1 },
                        { text: 'Cabeleleiro', item: 2, value: 2 },
                        { text: 'Comunicação', item: 3, value: 3 },
                        { text: 'Consultoria', item: 4, value: 4 },
                        { text: 'Contabilidade', item: 5, value: 5 },
                        { text: 'Jurídico', item: 6, value: 6 },
                        { text: 'Logístico', item: 7, value: 7 },
                        { text: 'Marcineiro', item: 8, value: 8 },
                        { text: 'Produção de Eventos', item: 9, value: 9 },
                        { text: 'Outros (especifique)', item: 10, value: 10 }
                    ]
                },
                serviceTypeOthers: null,
                buyer: {
                    selected: [],
                    options: [
                        { text: 'E-commerce', item: 1, value: 1 },
                        { text: 'Empresas', item: 2, value: 2 },
                        { text: 'Feira pública da cidade', item: 3, value: 3 },
                        { text: 'Pessoas de outras regiões além da minha', item: 4, value: 4 },
                        { text: 'Pessoas do meu bairro', item: 5, value: 5 },
                        { text: 'Outros (especifique)', item: 6, value: 6 }
                    ]
                },
                buyerOthers: null
            }
        }
    },
    validations: {
        form: {
            serviceType: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.serviceType.selected =
                data.tipo_servico === null ? [] : data.tipo_servico.filter(item => typeof item === 'number')

            this.form.serviceTypeOthers =
                data.tipo_servico === null
                    ? null
                    : data.tipo_servico.filter(item => typeof item !== 'number')[0].serviceTypeOthers

            this.form.buyer.selected =
                data.para_quem_vende_servico === null
                    ? []
                    : data.para_quem_vende_servico.filter(item => typeof item === 'number')

            this.form.buyerOthers =
                data.para_quem_vende_servico === null
                    ? null
                    : data.para_quem_vende_servico.filter(item => typeof item !== 'number')[0].buyerOthers

            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getAboutInitiative()])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.initiative = data

                        this.form.serviceType.selected =
                            data.tipo_servico === null ? [] : data.tipo_servico.filter(item => typeof item === 'number')

                        this.form.serviceTypeOthers =
                            data.tipo_servico === null
                                ? null
                                : data.tipo_servico.filter(item => typeof item !== 'number')[0].serviceTypeOthers

                        this.form.buyer.selected =
                            data.para_quem_vende_servico === null
                                ? []
                                : data.para_quem_vende_servico.filter(item => typeof item === 'number')

                        this.form.buyerOthers =
                            data.para_quem_vende_servico === null
                                ? null
                                : data.para_quem_vende_servico.filter(item => typeof item !== 'number')[0].buyerOthers
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                tipo_servico: this.form.serviceType.selected,
                para_quem_vende_servico: this.form.buyer.selected,
                percentual: currentProgress
            }

            data.tipo_servico = [...data.tipo_servico, { serviceTypeOthers: this.form.serviceTypeOthers }]
            data.para_quem_vende_servico = [...data.para_quem_vende_servico, { buyerOthers: this.form.buyerOthers }]

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({
                            name: this.initiative.interesse_em_ppp.includes(11)
                                ? 'AboutInitiativeForm7'
                                : 'AboutInitiativeForm9'
                        })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.serviceType.options = this.form.serviceType.options.filter(x =>
                    this.form.serviceType.selected.includes(x.value)
                )

                this.form.buyer.options = this.form.buyer.options.filter(x =>
                    this.form.buyer.selected.includes(x.value)
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm14-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm14.vue